import { combineReducers } from 'redux-immutable'
import { connectRouter } from 'connected-react-router/immutable'
import user from './user'
import blackword from './blackword'
import policy from './policy'
import statistic from './statistic'
import monitor from './monitor'
import strategy from './strategy'
import website from './website'
import alarm from './alarm'
import blog from './blog'

export default history =>
  combineReducers({
    // router 的，千万不要删除
    router: connectRouter(history),
    // 自定义的state
    user,
    blackword,
    policy,
    statistic,
    monitor,
    strategy,
    website,
    alarm,
    blog
  })
